import React from "react";
import { useSelector } from "react-redux";
import { Card, Title } from "@mantine/core";

import { ManagementLayout } from "@components/shared";
import {
  BulkCommunicationList,
  BulkCommunicationForm,
} from "@components/BulkCommunication";

export default function BulkCommunicationManagement({
  locationId,
  orgId,
  effortId,
}) {
  const managerInfo = useSelector((state) => state.manager);
  const formattedLocationId = managerInfo?.location_id || locationId;
  const formattedOrgId = managerInfo?.organization_id || orgId;

  // admin index view
  if (!managerInfo && !locationId && !orgId && !effortId)
    return <BulkCommunicationList />;

  return (
    <div>
      <ManagementLayout
        dataComponent={
          <>
            <BulkCommunicationList
              locationId={formattedLocationId}
              orgId={formattedOrgId}
              effortId={effortId}
            />
          </>
        }
        createComponent={
          <Card>
            <Title order={4}>Create Bulk Communication</Title>
            <BulkCommunicationForm
              locationId={formattedLocationId}
              orgId={formattedOrgId}
              effortId={effortId}
            />
          </Card>
        }
      />
    </div>
  );
}
